import { render, staticRenderFns } from "./DisplayFormBuilderComponent.vue?vue&type=template&id=75ffbe86&scoped=true&"
import script from "./DisplayFormBuilderComponent.vue?vue&type=script&lang=js&"
export * from "./DisplayFormBuilderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ffbe86",
  null
  
)

export default component.exports